<template>
  <div id="pos-covid-19" class="row">
    <div class="col-md-12">
      <selects
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="true"
        :callbackOnChangeProfissional="onChangeProfissional"
      ></selects>
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <!--  <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setRed="setRed"
                      @resetarNome="setRed = false"
                    ></Subtitle> -->
                    <div class="info-table-item">
                      <vue-select
                        :options="groupFilterItems"
                        label="label"
                        placeholder="Pós Covid ?"
                        v-model="groupFilter"
                        @input="handleSituacao($event)"
                        :clearable="true"
                      >
                        <template slot="option" slot-scope="option">
                          {{ option.label }}
                        </template>
                        <div slot="no-options">
                          Não há opções correspondentes
                        </div>
                      </vue-select>
                    </div>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="pos-covid-19"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros
                  ref="table"
                  :cadastros="displayedCadastros"
                  :loading="loadingLista"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions'
import TabelaCadastros from './TabelaCadastros.vue'
import { dataFields, infoHtml } from './utils.js'
import utils from '@/mixins/utils.js'
import TitleTag from '@/components/TitleTag.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import Selects from '@/components/utils/Selects.vue'

export default {
  name: 'PosCovid19PorEquipeAcs',
  components: {
    PulseLoader,
    Loader,
    Subtitle,
    TabelaCadastros,
    TitleTag,
    DownloadFiles,
    Selects,
  },
  mixins: [utils],
  data() {
    return {
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      loadingLista: false,
      tabsActive: 0,
      nomeProfissional: '',
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      cadastrosOriginais: [],
      setRed: false,
      text: infoHtml,
      equipeEvent: '',
      filterSearchTable: false,
      groupFilterItems: [
        {
          label: 'Sim',
          value: 'Sim',
        },
        {
          label: 'Não',
          value: 'Não',
        },
      ],
      groupFilter: '',
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      /*       if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      } */
      if (this.profissional !== '' && this.profissional !== null) {
        let profissionaisFiltrados = data.filter((el) => {
          return el.profissional === this.profissional
        })
        data = profissionaisFiltrados
      }

      const filtrado = data.filter((item) => {
        if (this.groupFilter == null || this.groupFilter == '') {
          return item
        }
        if (this.groupFilter.value === 'Sim') {
          return item.pos_covid == '1'
        }
        if (this.groupFilter.value === 'Não') {
          return item.pos_covid == '0'
        }
      })
      data = filtrado

      this.cadastros = data
    },

    handleSituacao(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.groupFilter = event
      this.filtros(true, false)
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.equipeEvent = event
        this.tabsActive = 0
        this.profissionais = []
        this.profissional = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = event.nu_ine
        this.groupFilter = ''
        this.buscarCadastrosIndividuaisTodosPorEquipe()
      } else {
        this.equipeEvent = ''
        this.profissionais = []
        this.profissional = ''
        this.tabsActive = 0
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = ''

        return
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.profissional = event?.nu_cpf
        this.nomeProfissional = event?.no_profissional
        this.tabsActive = 0
        this.page = 1
        if (this.profisional == null) {
          this.tabsActive = 0
        }
        this.filtros(true, false)
        this.setRed = true
      } else {
        this.cadastros = []
        this.cadastros = this.cadastrosOriginais
        this.temAcs = false
        this.profissional = ''
        this.nomeProfissional = ''
        return
      }
    },

    async buscarCadastrosIndividuaisTodosPorEquipe() {
      this.loadingLista = true
      let response = await Functions.getCadastrosIndividuaisTodosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe
      )
      if (response) {
        this.cadastrosOriginais = response
        this.cadastros = response
        this.filtros(true, false)
        this.setRed = true
        this.loadingLista = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipeEvent,
        this.profissional,
        this.nomeProfissional
      )
    },
  },
  created() {},
}
</script>

<style>
@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
@media screen and (max-width: 992px) {
  .info-table {
    flex-direction: column;
  }
}
</style>
<style>
.resultado-pos-covid-19 {
  cursor: pointer;
  display: flex;
  padding: 10px 1rem;
  gap: 15px;
  font-size: 20px;
  color: black;
  background: white;
  justify-content: flex-end;
  padding-bottom: 5px;
}
.resultado-pos-covid-19 .esus-feedback-tabs ul li .nav-link {
  padding-top: 0;
  padding-bottom: 0;
}
.resultado-pos-covid-19 .esus-feedback-tabs ul {
  background: #0fafd726;
  border-radius: 5px;
  padding: 0px 1px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.resultado-pos-covid-19 .esus-feedback-tabs ul li .nav-link.active {
  transition: all ease 0.3s;
  border-color: unset !important;
  border-bottom: unset;
  border: unset;
}
.resultado-pos-covid-19 .esus-feedback-tabs ul li:first-child .nav-link.active {
  background-color: #0056b3 !important;
  color: white !important;
  border-radius: 5px 0px 0px 5px;
  animation: left 0.5s ease 0s 1 normal forwards;
}
.resultado-pos-covid-19 .esus-feedback-tabs ul li:last-child .nav-link.active {
  background-color: #0056b3 !important;
  color: white !important;
  border-radius: 0px 5px 5px 0px;
  animation: right 0.5s ease 0s 1 normal forwards;
}
.resultado-pos-covid-19 .nav-tabs {
  border-bottom: unset;
}
@keyframes right {
  0% {
    transform: translateX(-40px);
  }

  100% {
    transform: translateX(0px);
  }
}
@keyframes left {
  0% {
    transform: translateX(40px);
  }

  100% {
    transform: translateX(0px);
  }
}
</style>
